import { ArrowRightOutlined } from '@ant-design/icons';

import { Category, Document } from 'interfaces/documents';
import { useModal } from 'hooks/useModal';
import { moveDocument, refreshDocumentTreeLevels } from 'slices/documentsActions';
import { moveCategory } from 'slices/categoriesActions';
import { useAppDispatch } from 'utilities/hooks';
import { containingFolderOf } from 'utilities/documentTree';
import { MenuItemType } from 'antd/es/menu/interface';

export const Move = (
    row: Category | Document,
    fetchData: () => void
): MenuItemType => {
    const dispatch = useAppDispatch();
    const { openModal } = useModal();

    const moveItem = async (destination: Category | null) => {
        const source = containingFolderOf(row);

        if ((row as Category).type === 'category') {
            await dispatch(moveCategory({
                id: (row as Category).uuid,
                parent_id: destination?.id || null,
            }));
        } else {
            await dispatch(moveDocument({
                id: (row as Document).id,
                category_id: destination?.id || null,
            }));
        }

        dispatch(refreshDocumentTreeLevels([source, destination?.id]));
        fetchData();
    };

    return {
        key: 'Move',
        label: 'Move',
        onClick: () => {
            openModal('categoriesTreeModal', {
                title: 'Move to...',
                submitLabel: 'Move',
                cancelLabel: 'Cancel',
                parentId: (row as Category).parent_id || (row as Document).category_id,
            }, {
                onSubmit: (value: Category | null) => {
                    moveItem(value);
                }
            });
        },
        icon: <ArrowRightOutlined />,
    };
}